module.exports = __webpack_public_path__ + "static/media/game-reward-head@2x.a0b3bfaf.png";